import React from 'react';
import {
  FaSearch,
  FaBitcoin,
  FaRegCreditCard
} from "react-icons/fa"; //Font Awesome 5
import {
  Button,
  Form,
  Input,
  DatePicker,
  Select,
  Row,
  Col,
  Typography,
  Table,
  Skeleton,
  Result,
  Statistic,
  Tag,
} from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { paymentTypes, formatPhone } from '../../utils/customFunctions';

const billingStatus = [
  // { key: 'created', label: 'CREATED', value: 'CREATED' },
  { key: 'completed', label: 'COMPLETED', value: 'COMPLETED' },
  { key: 'canceled', label: 'CANCELED', value: 'CANCELED' },
]

const columns = [
  {
    title: 'Date',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${text.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {dayjs(text.order_date).format('DD-MM-YYYY')}
      </Button>
  },
  {
    title: 'Order no.',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${text.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text.order_no}
      </Button>
  },
  {
    title: 'Student',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${text.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {`${text.student.fname_th ?? ""}  ${text.student.lname_th ?? ""}`}
      </Button>
  },
  {
    title: 'Student ID',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${text.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text.student.student_code}
      </Button>
  },
  {
    title: 'Phone',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${text.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {formatPhone(text.student.parent.phone)}
      </Button>
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    render: (text, record) => (
      <Button
        type='text'
        href={`/admin/orders/${record.order.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        <div>
          <span style={{ display: 'block', fontWeight: 'bold', fontSize: '12px' }}>
            {`${text.name ?? ""}`}
          </span>
          {text.category?.name === 'course' && <span style={{ fontSize: '12px' }}>
            {`เริ่มเรียน ${dayjs(record.start_date).format('DD-MM-YYYY')} ถึง ${dayjs(record.end_date).format('DD-MM-YYYY')}`}
          </span>}
        </div>
      </Button>
    )
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record.order.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
      </Button>
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record.order.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
      </Button>
  },
  {
    title: 'Payment Type',
    dataIndex: 'order',
    key: 'order',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record.order.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>{
          text.payment_type === 'CASH' ?
            <div style={{ color: '#55C522' }}>
              <FaBitcoin style={{ marginRight: '4px' }} />
              {text.payment_type}
            </div> :
            <div style={{ color: '#3487FF' }}>
              <FaRegCreditCard style={{ marginRight: '4px' }} />
              {text.payment_type}
            </div>
        }</Button>
  },
  {
    title: 'Status',
    dataIndex: 'order',
    key: 'order',
    // align: 'center',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/orders/${record.order.id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>{
          <Tag color={text.order_status === 'COMPLETED' ? "green" : "red"} style={{ borderRadius: '20px' }}>{text.order_status}</Tag>
        }</Button>
  },
]

function OrderSearch() {
  const redirect = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();
  const start_date = new URLSearchParams(location.search).get('start_date');
  const end_date = new URLSearchParams(location.search).get('end_date');
  const product = new URLSearchParams(location.search).get('product');
  const payment_type = new URLSearchParams(location.search).get('payment_type');
  const order_status = new URLSearchParams(location.search).get('order_status');
  const q = new URLSearchParams(location.search).get('q');

  let apiText = `/api/orderItems/getOrderItemBySearch?${window.location.href.split("?")[1]}`;

  const ordersQuery = useQuery({
    queryKey: [apiText],
  })
  const productQuery = useQuery({ queryKey: ['/api/products/getAllCourseProducts'] });

  if (ordersQuery.isLoading || productQuery.isLoading) {
    return <Skeleton active />
  }

  if (ordersQuery.isError || productQuery.isError) {
    return <Result
      status="error"
      title={ordersQuery.error.message || productQuery.error.message} />
  };

  const onSearch = e => {
    form
      .validateFields()
      .then(info => {

        let searchText = `/admin/orders/searchOrder?`;
        if (info.date) {
          searchText += `&start_date=${dayjs(info.date[0]).format('YYYY-MM-DD')}`;
          searchText += `&end_date=${dayjs(info.date[1]).format('YYYY-MM-DD')}`;
        }
        if (info.product) searchText += `&product=${info.product}`;
        if (info.payment_type) searchText += `&payment_type=${info.payment_type}`;
        if (info.order_status) searchText += `&order_status=${info.order_status}`;
        if (info.q) searchText += `&q=${info.q}`;

        redirect(searchText);
      })
      .catch(err => {
        console.log(err)
      })
  }

  // console.log('ordersQuery.data = ', ordersQuery.data);
  // console.log('productQuery.data :', productQuery.data);
  return (
    <div >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Row >
            <Col>
              <Typography.Title level={3}>
                Search Order
              </Typography.Title>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Form
            form={form}
            name='searchOrders'
            initialValues={{
              ...((start_date && end_date) && { date: [dayjs(start_date), dayjs(end_date)] }),
              product,
              payment_type,
              order_status,
              q
            }}
          >
            <Row justify='space-between' gutter={[8, 0]}>
              <Col xs={24} md={8}>
                <Form.Item name="date" label="">
                  <DatePicker.RangePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label=""
                  name="payment_type"
                >
                  <Select
                    placeholder="Select payment type"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {paymentTypes.map(type => <Select.Option key={type.value} value={type.value}>
                      {type.label_th}
                    </Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="order_status" label="">
                  <Select
                    placeholder="Select status"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {billingStatus.map(status => <Select.Option key={status.key} value={status.value}>
                      {status.label}
                    </Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label=""
                  name="product"
                >
                  <Select
                    placeholder="Select courses or otther products"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {productQuery.data.map(p => <Select.Option key={p._id} value={p.id}>
                      {p.name}
                    </Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col flex={1} >
                <Form.Item label="" name="q">
                  <Input
                    allowClear
                    placeholder="Search Student name, Student ID or Phone" />
                </Form.Item>
              </Col>
              <Col>
                <Button
                  type='primary'
                  icon={<FaSearch />}
                  onClick={onSearch}
                  style={{ width: '100%' }}
                >Search</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={ordersQuery.data}
            scroll={{
              x: 1200,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default OrderSearch